import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import MessageIcon from '@mui/icons-material/Message';
import GroupIcon from '@mui/icons-material/Group';
import { DEFAULT_THEME_COLOR } from '../../constants/theme';

function formatRoomTime(dateStr) {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  const now = new Date();
  const isToday =
    date.getDate() === now.getDate() &&
    date.getMonth() === now.getMonth() &&
    date.getFullYear() === now.getFullYear();
  if (isToday) return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

  const yesterday = new Date(now);
  yesterday.setDate(now.getDate() - 1);
  const isYesterday =
    date.getDate() === yesterday.getDate() &&
    date.getMonth() === yesterday.getMonth() &&
    date.getFullYear() === yesterday.getFullYear();
  if (isYesterday) return 'Yesterday';

  if (now - date < 7 * 86400000) return date.toLocaleDateString([], { weekday: 'short' });
  return date.toLocaleDateString([], { month: '2-digit', day: '2-digit' });
}

export default function ChatRoomListItem({ room, onPress, onLeave }) {
  const lastLine = room.lastMessage
    ? `${room.lastMessage.sender_username}: ${room.lastMessage.content}`
    : 'No messages yet';

  return (
    <Box
      onClick={onPress}
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        px: 2,
        py: 1.25,
        mx: 1,
        my: 0.5,
        borderRadius: 2,
        cursor: 'pointer',
        backgroundColor: 'rgba(255,255,255,0.04)',
        border: '1px solid rgba(255,255,255,0.06)',
        transition: 'background 0.15s',
        position: 'relative',
        '&:hover': {
          backgroundColor: 'rgba(54,201,162,0.08)',
          borderColor: 'rgba(54,201,162,0.2)',
          '& .leave-btn': { opacity: 1 },
        },
      }}
    >
      <Box
        sx={{
          width: 40,
          height: 40,
          borderRadius: '50%',
          backgroundColor: DEFAULT_THEME_COLOR,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
        }}
      >
        {room.type === 'dm'
          ? <MessageIcon sx={{ color: 'white', fontSize: 20 }} />
          : <GroupIcon sx={{ color: 'white', fontSize: 20 }} />
        }
      </Box>
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography variant="body2" sx={{ color: 'white', fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          {room.name || 'Chat'}
        </Typography>
        <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.45)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'block' }}>
          {lastLine}
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 0.25, flexShrink: 0 }}>
        <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.35)', fontSize: '0.65rem', whiteSpace: 'nowrap' }}>
          {formatRoomTime(room.lastMessage?.created_at || room.created_at)}
        </Typography>
        {room.unreadCount > 0 && (
          <Box
            sx={{
              minWidth: 20,
              height: 20,
              borderRadius: 10,
              backgroundColor: DEFAULT_THEME_COLOR,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              px: 0.75,
            }}
          >
            <Typography variant="caption" sx={{ color: 'white', fontWeight: 700, fontSize: '0.65rem' }}>
              {room.unreadCount > 99 ? '99+' : room.unreadCount}
            </Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
}
